import React, { Component } from 'react'
import { Col } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

export default function MenuCard({ handleMenuCallback, icon = null, name = '', description = '', key }) {
    const {t}=useTranslation();
    return (
        <Col
            onClick={handleMenuCallback}
            xs={'auto'}
            sm={'auto'}
            md={'auto'}
            key={key}
            className='account-menu-card'>
            <img width={52} height={40} src={icon} />
            <h2>{t(name)}</h2>
            <span>{t(description)}</span>
        </Col>
    )
}